import { faBars, faHouse, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RequestCallback from './RequestCallback';
import WeDoBetter from './WeDoBetter';
import DescriptionTemplate from './DescriptionTemplate';

const posterSrc = 'https://dt7j04u1665qi.cloudfront.net/SellYourProperty.webp'
const FootCompTemplate = ({
    heading,
    desc,
    paraText,
    paraText2,
    subHeading
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showLogo, setShowLogo] = useState(false);

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    useEffect(() => {
        // Simulate delay for logo animation (You can adjust the delay value)
        const logoAnimationDelay = setTimeout(() => {
            setShowLogo(true);
        }, 500);

        // Clean up the timeout to prevent memory leaks
        return () => clearTimeout(logoAnimationDelay);
    }, []);

    const closeMenu = () => {
        setShowMenu(false);
    };

    return (
        <>
            <header id="home" className="tracking-widest relative min-h-[75vh] sm:min-h-[85vh] flex flex-col justify-between overflow-hidden">
                <div className="w-full h-full object-cover absolute inset-0 z-0">
                    <img
                        src={posterSrc}
                        className="w-full h-full object-cover"
                        loading="lazy" alt="Video Poster"
                    />
                </div>
                <div className="absolute inset-0 bg-black/60 z-0" />

                {/* Top Nav */}
                <div className="relative z-10 w-full p-4 sm:p-6">
                    <div className="max-w-7xl mx-auto flex items-center justify-between">
                        <Link to="/" className="flex items-center">
                            {showLogo && (
                                <div className="w-36 sm:w-48 md:w-56 text-white animate-slideInLeft">
                                    <img
                                        src="https://dt7j04u1665qi.cloudfront.net/all_brands_logos_170-40.webp"
                                        className="w-full h-auto object-contain"
                                        loading="lazy" alt="Logo"
                                    />
                                </div>
                            )}
                        </Link>

                        {/* Mobile Menu Button */}
                        <div className="md:hidden">
                            <button aria-label="Toggle menu" onClick={toggleMenu} className="text-white p-2 rounded-md hover:bg-white/10 text-xl">
                                <FontAwesomeIcon icon={faBars} />
                            </button>
                        </div>

                        {/* Desktop Navigation Buttons */}
                        <nav className="hidden font-light md:flex items-center space-x-6 text-sm">
                            <Link to="/connect" className="btn-header text-white hover:text-gray-300 flex items-center">
                                <FontAwesomeIcon icon={faSearch} className='mr-2' /> PROPERTY SEARCH
                            </Link>
                            <div className="h-4 border-r border-white/60"></div>
                            <Link to="/ListProperty" className="btn-header text-white hover:text-gray-300 flex items-center">
                                <FontAwesomeIcon icon={faHouse} className='mr-2' /> LIST YOUR PROPERTY
                            </Link>
                            <div className="h-4 border-r border-white/60"></div>
                            <button onClick={toggleMenu} className="btn-header text-white hover:text-gray-300 flex items-center cursor-pointer">
                                <FontAwesomeIcon icon={faBars} className='mr-2' /> MENU
                            </button>
                        </nav>
                    </div>
                </div>

                {/* Mobile Backdrop */}
                {showMenu && (
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-xs z-50 transition-opacity duration-300"
                        onClick={closeMenu}
                        aria-hidden="true"
                    />
                )}

                {/* Mobile Drawer */}
                <div
                    className={`fixed top-0 right-0 bottom-0 w-4/5 max-w-sm bg-white z-50 shadow-2xl p-6 overflow-y-auto transform transition-transform duration-300 ease-in-out ${
                        showMenu ? 'translate-x-0' : 'translate-x-full'
                    }`}
                >
                    <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                        <span className="text-xl font-bold tracking-widest text-black">HAIDERIES</span>
                        <button onClick={closeMenu} aria-label="Close menu" className="p-2 text-gray-500 hover:text-black">
                            ✕
                        </button>
                    </div>
                    <nav className="py-6 flex flex-col space-y-3">
                        <Link to='/' onClick={closeMenu} className="px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg">Home</Link>
                        <Link to='/connect' onClick={closeMenu} className="px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg">Property Search</Link>
                        <Link to='/ListProperty' onClick={closeMenu} className="px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg">List Your Property</Link>
                        <Link to='/WhyHaideries' onClick={closeMenu} className="px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg">About Us</Link>
                        <Link to='/Contact' onClick={closeMenu} className="px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg">Contact Us</Link>
                    </nav>
                </div>

                {/* Hero Content */}
                <div className="relative z-10 flex-1 flex flex-col justify-center items-center px-4 sm:px-6 md:px-8 py-10 text-center">
                    <div className="max-w-4xl mx-auto mb-8">
                        <h1 className={`tracking-widest text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-thin mb-2 ${showLogo ? 'animate-slideInLeft' : ''}`}>
                            {heading}
                        </h1>
                        {heading === 'SELL YOUR PROPERTY WITH' && (
                            <h2 className={`tracking-widest text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-thin ${showLogo ? 'animate-slideInRight' : ''}`}>
                                HAIDERIES REAL ESTATE
                            </h2>
                        )}
                    </div>

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-md">
                        <Link to="/WhyHaideries" className="w-full sm:w-auto">
                            <button className="w-full sm:w-52 py-3.5 px-6 bg-black hover:bg-white hover:text-black text-white font-semibold rounded-md border border-white/30 text-xs sm:text-sm tracking-widest transition-colors">
                                MEET OUR TEAM
                            </button>
                        </Link>
                        <Link to="/Contact" className="w-full sm:w-auto">
                            <button className="w-full sm:w-52 py-3.5 px-6 bg-white hover:bg-black hover:text-white text-black font-semibold rounded-md border border-white text-xs sm:text-sm tracking-widest transition-colors">
                                CONTACT US
                            </button>
                        </Link>
                    </div>
                </div>
            </header>
            <DescriptionTemplate
                heading={heading}
                desc={desc}
                paraText={paraText}
                paraText2={paraText2}
                subHeading={subHeading}
            />
            <WeDoBetter />
            <RequestCallback />
        </>
    );
};

export default FootCompTemplate;